import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";

@Injectable()
export class AuthguardGuard implements CanActivate {
  firstTime: any;
  constructor(private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    let userDetails = localStorage.getItem("userDetails");

    if (userDetails) {
      let userDetJson = JSON.parse(userDetails);
      this.firstTime = userDetJson.newPassword;
      if (localStorage.getItem("currentUser") && this.firstTime != true) {
        // logged in so return true
        return true;
      }
      // not logged in so redirect to login page with the return url
      this.router.navigate(["/login"]);
      return false;
    }

  }
}
